if (!window.cardProductSwatchSelectionInit) {
  window.cardProductSwatchSelectionInit = true;
  window.cardProductMediaSlots = {
    desktopPrimary: 'desktop-primary',
    desktopHover: 'desktop-hover',
    mobileSlider: 'mobile-slider',
    mobilePrimary: 'mobile-primary',
    mobileCollection: 'mobile-collection',
  };

  window.cardProductSwatchSelector =
    '.swatch-list__item, .Card_product_variant_swatches_item_new';

  window.cardProductActiveSwatchSelector =
    '.swatch-list__item.is-active, .Card_product_variant_swatches_item_new.is-active';

  window.parseCardProductMediaPayload = function (payloadElement) {
    if (!payloadElement) {
      return {};
    }

    try {
      return JSON.parse(payloadElement.textContent.trim());
    } catch (error) {
      console.error('Failed to parse product card media payload.', error);
      return {};
    }
  };

  window.createCardProductMediaNode = function (markup) {
    if (!markup) {
      return null;
    }

    const template = document.createElement('template');
    template.innerHTML = markup.trim();

    return template.content.firstElementChild;
  };

  window.replaceCardProductMediaSlot = function (
    cardWrapper,
    slotKey,
    markup
  ) {
    if (!markup) {
      return;
    }

    const slotName = window.cardProductMediaSlots[slotKey];
    if (!slotName) {
      return;
    }

    const currentNode = cardWrapper.querySelector(
      '[data-card-media-slot="' + slotName + '"]'
    );
    if (!currentNode) {
      return;
    }

    const nextNode = window.createCardProductMediaNode(markup);
    if (!nextNode) {
      return;
    }

    currentNode.replaceWith(nextNode);
  };

  window.updateCardProductMediaFromSwatch = function (
    cardWrapper,
    swatchButton
  ) {
    if (!cardWrapper || !swatchButton) {
      return;
    }

    const defaultPayload = window.parseCardProductMediaPayload(
      cardWrapper.querySelector('[data-card-default-media]')
    );
    const swatchPayload = window.parseCardProductMediaPayload(
      swatchButton.querySelector('[data-card-variant-media]')
    );

    Object.keys(window.cardProductMediaSlots).forEach(function (slotKey) {
      window.replaceCardProductMediaSlot(
        cardWrapper,
        slotKey,
        swatchPayload[slotKey] || defaultPayload[slotKey]
      );
    });
  };

  window.getCardProductSwatchWrapper = function (element) {
    return element.closest(
      '.product-card-wrapper, .card-product, [data-product-cross-sell]'
    );
  };

  window.updateCrossSellPricesFromSwatch = function (root, swatchButton) {
    if (!root || !swatchButton || !root.hasAttribute('data-product-cross-sell')) {
      return;
    }

    const priceEl = root.querySelector('[data-cross-sell-price]');
    const compareEl = root.querySelector('[data-cross-sell-compare-at]');
    if (!priceEl) {
      return;
    }

    const price = swatchButton.getAttribute('data-price') || '';
    const compareAt = swatchButton.getAttribute('data-compare-at') || '';

    priceEl.textContent = price;

    if (compareEl) {
      const compareValueEl = compareEl.querySelector(
        '[data-cross-sell-compare-at-value]'
      );

      if (compareAt) {
        if (compareValueEl) {
          compareValueEl.textContent = compareAt;
        }
        compareEl.classList.remove('hidden');
      } else {
        if (compareValueEl) {
          compareValueEl.textContent = '';
        }
        compareEl.classList.add('hidden');
      }
    }
  };

  window.syncCardProductSwatches = function (root) {
    const scope = root || document;
    const activeSwatches = scope.querySelectorAll(
      window.cardProductActiveSwatchSelector
    );

    activeSwatches.forEach(function (swatchButton) {
      const cardWrapper = window.getCardProductSwatchWrapper(swatchButton);
      if (!cardWrapper) {
        return;
      }

      window.updateCardProductMediaFromSwatch(cardWrapper, swatchButton);
    });
  };

  document.addEventListener('click', function (event) {
    const swatchButton = event.target.closest(
      window.cardProductSwatchSelector
    );

    if (!swatchButton) {
      return;
    }

    const cardWrapper = window.getCardProductSwatchWrapper(swatchButton);
    if (!cardWrapper) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    const variantId = swatchButton.getAttribute('data-variant-id');
    const variantUrl = swatchButton.getAttribute('data-variant-url');
    if (!variantId || !variantUrl) {
      return;
    }

    const swatchButtons = cardWrapper.querySelectorAll(
      window.cardProductSwatchSelector
    );
    swatchButtons.forEach(function (button) {
      button.classList.remove('is-active');
      button.setAttribute('aria-pressed', 'false');
    });

    swatchButton.classList.add('is-active');
    swatchButton.setAttribute('aria-pressed', 'true');

    const variantInput = cardWrapper.querySelector('.product-variant-id');
    if (variantInput) {
      variantInput.value = variantId;
      variantInput.disabled = false;
    }

    const productLinks = cardWrapper.querySelectorAll('[data-product-card-link]');
    productLinks.forEach(function (link) {
      link.setAttribute('href', variantUrl);
    });

    window.updateCardProductMediaFromSwatch(cardWrapper, swatchButton);
    window.updateCrossSellPricesFromSwatch(cardWrapper, swatchButton);
  });

  document.addEventListener('stitcher-slider:init', function () {
    window.syncCardProductSwatches(document);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      window.syncCardProductSwatches(document);
    });
  } else {
    window.syncCardProductSwatches(document);
  }
}
